import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import api from "../../services/api"



import Header from "./content/header"

class RemoveMatriculaAdm extends Component {

state= {
  matricula:[],
  idmatricula:null,
  precoinscricao:null,
  status:null,
  error:null,
  paid:null,
  success:null,
  aluno:null
}

    async componentDidMount(){


      const response = await api.post("/admin/matricula/id", { idmatricula:this.props.match.params.idmatricula });
      this.setState({
        matricula:response.data,
        idmatricula:this.props.match.params.idmatricula,
        precoinscricao:response.data.price,
        status:response.data.status,
        paid:response.data.paid,
        aluno:response.data.user.dados_users.nomecompleto
      })
    
    }








    rmmatricula = async e => {
    e.preventDefault();
    const { idmatricula} = this.state;
      if (!idmatricula) {
          this.setState({ error: "Preencha os dados antes de excluir!",
        success:null });
          
      } else {
      const { idmatricula } = this.state;
      const response = await api.post("/admin/matricula/del", { idmatricula });

        if(response.data.id){
         
          this.props.history.goBack();
        }

      }
  }


  render() {
    return (
      <React.Fragment>
          <Header />
        <div class="container col-sm-4 p-4">     

        <h4>Remover Matricula</h4>     
        <form onSubmit={this.rmmatricula}>
        {this.state.error && <p>{this.state.error}</p>}
        {this.state.success && <p>{this.state.success}</p>}

                <div class="form-group">
                    <label for="exampleFormControlInput1">Aluno</label>
                    <input type="text" class="form-control" value={this.state.aluno} disabled />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Preço Inscrição</label>
                    <input disabled type="text" class="form-control" defaultValue={this.state.precoinscricao} onChange={e => this.setState({ precoinscricao: e.target.value })} />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Pagamento</label>
                    <select disabled class="browser-default custom-select" onChange={e => this.setState({ paid: e.target.value })}>
                      <option value="true" selected={this.state.paid==true}>Efetuado</option>
                      <option value="false" selected={this.state.paid==false}>Não Efetuado</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Status</label>
                    <select disabled class="browser-default custom-select" onChange={e => this.setState({ status: e.target.value })} >
                      <option value="0" selected={this.state.status==0}>Pendente</option>
                      <option value="1" selected={this.state.status==1}>Ativo</option>
                      <option value="1" selected={this.state.status==2}>Cancelada</option>
                      <option value="4" selected={this.state.status==4}>Concluída</option>
                      <option value="5" selected={this.state.status==5}>Concluída com Pendência</option>
                      <option value="6" selected={this.state.status==6}>Formado</option>
                      <option value="7" selected={this.state.status==7}>Ativa Totalmente Paga</option>
                    </select>
                </div>
                <div class="form-group">
                <button class="btn btn-danger mb-2">Remover Matricula</button>

                </div>
        </form>
















    </div>
      </React.Fragment>
       
    );
  }
}

export default withRouter(RemoveMatriculaAdm);


// WEBPACK FOOTER //
// ./src/pages/Admin/removematricula.js